/**
 * @deprecated To remove
 */
export const DietProductionStepItem = (json: IDietProductionStepItem): IDietProductionStepItemModel => {
	const { is_active, updated_at, created_at, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * @deprecated To remove
 */
export const dietProductionStepItemToJSON = (model: IDietProductionStepItemModel): IDietProductionStepItem => {
	const { isActive, createdAt, updatedAt, ...rest } = model

	return {
		...rest,
		is_active: isActive ?? false,
		created_at: createdAt ? createdAt.toISOString() : null,
		updated_at: updatedAt ? updatedAt.toISOString() : null,
	}
}

/**
 * @deprecated To remove
 */
export const DietProductionStep = (json: IDietProductionStep): IDietProductionStepModel => {
	const { production_stage_id, production_stage, parameter_settings, id, ...rest } = json

	return {
		...rest,
		id: id ?? 0, // Ensure id is always a number
		productionStageId: production_stage_id,
		productionStage: DietProductionStepItem(production_stage),
		parameterSettings: parameter_settings,
	}
}

/**
 * @deprecated To remove
 */
export const dietProductionStepToJSON = (model: IDietProductionStepModel): IDietProductionStep => {
	const { productionStageId, productionStage, parameterSettings, ...rest } = model

	return {
		...rest,
		production_stage_id: productionStageId,
		production_stage: dietProductionStepItemToJSON(productionStage),
		parameter_settings: parameterSettings,
	}
}

/**
 * @deprecated To remove
 */
export const DietProductionStepForm = (json: IDietProductionStepModel): IDietProductionStepFormModel => {
	const { components, parameterSettings, order, description, productionStage, productionStageId } = json

	return {
		productionStageId,
		productionStage,
		order,
		description,
		parameterSettings,
		components: components.map(c => ({ id: c.id, type: c.type })),
	}
}

/**
 * @deprecated To remove
 */
export const DietProductionStepToForm = (model: IDietMealProductionStepModel): IDietProductionStepFormModel => {
	const { order, productionStage, description, parameterSettings } = model

	return {
		order,
		description,
		parameterSettings,
		productionStageId: productionStage.id,
		productionStage: { value: productionStage.id, label: productionStage.name },
		components: [],
	}
}

/**
 * Payloads
 * @deprecated To remove
 */
export const DietProductionStepToPayload = (model: IDietProductionStepModel): IDietProductionStepPayload => {
	const { productionStage, components, description, parameterSettings, ...rest } = model

	return {
		...rest,
		description: description ?? null,
		production_stage_id: productionStage.value,
		parameter_settings: parameterSettings ?? null,
		components: [],
	}
}
